import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import * as moment from 'moment-timezone';
import {
    timeDifferenceInSeconds,
    getCurrentUser,
    secondsToMinutesHour,
} from "_helpers";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MessageLockIcon from '@mui/icons-material/Lock';
import TimerIcon from '@mui/icons-material/Schedule';
import React, { Component } from "react";
import { MessageActionsV2 } from './MessageActionsV2';
import _ from "lodash";
import { LOCK_DURATION_IN_SECS } from "_constants";
import { MessageStatusV2 } from "components/Message-V2";
import Checkbox from '@mui/material/Checkbox';
import { showGreenTimer, showRedTimer } from "_helpers";
import processPlaceholder from "../v2/common/Message/Utilities/MessageUtils";
import IconButton from "@mui/material/IconButton";
import styles from "./Styles.module.css"
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import {Box, Typography} from "@mui/material";
import BasicTooltip from "../v2/common/BasicTooltip";

const INCOMING = 'incoming';
const OUTGOING = 'outgoing';

class MessagesRowV2 extends Component {

    state = {
        anchorElement: null,
        setCheckbox: false,
    };

    /**
     * Identifies the clicked item and opens the popup menu for the three dots
     * @param event
     */
    handleClick = event => {
        this.setState({anchorElement: event.currentTarget});
    };


    /**
     * Responsible for closing the popup menu
     */
    handleClose = () => {
        this.setState({anchorElement: null});
    };

    render() {

        const {
            message, deleteMessageFromSource, escalateMessage, getCheckboxMessages,
            skipMessage, updateMessageFromSource, platform, classes,closeModalHandler,
            showModalHandle, undoMessage, selectedMessages, selectItem, showSelectAll, blacklist,
            likeMessageFromSource, resendForResponseGenList, sendMessageForResponseGen, actionMessage

        } = this.props;

        const { anchorElement, setCheckbox } = this.state;
        const open = Boolean(anchorElement);
        let _selectedMessages = selectedMessages || [];

        /**
         * Shorten string and add ellipses if the length of text exceeds 60 characters
         * actioned in this context is for an INCOMING message (when messages are escalated or marked as no response needed)
         */
        const messageActioned = message.actioned ? message.actioned : (message.userMessageActions && message.userMessageActions.length > 0);
        let text = processPlaceholder(message.text);
        const zone_name =  moment.tz.guess();
        const timezone = moment.tz(zone_name).zoneAbbr();
        const messageId = String(_.get(message, 'id'));
        const direction = _.get(message, 'direction');
        const hasEmployeeSeen = _.get(message, 'hasEmployeeSeen');
        const needsAdminAction = _.get(message, 'needsAdminAction');
        const dateCreated = _.get(message, 'dateCreated');
        const createdDate = _.get(message, 'dateCreatedFromSource');
        const lockedAtTime = _.get(message, 'lockedAtTime');
        const isAutoEscalated = _.get(message, 'isAutoEscalated');
        const handleType = _.get(message, 'handleType');
        let isChecked = _selectedMessages.includes(messageId);
        let showCheckbox = direction && direction.toLowerCase() === INCOMING && !isAutoEscalated && (!hasEmployeeSeen || needsAdminAction) && !messageActioned;
        let lockedMsgTimeDiff = timeDifferenceInSeconds(moment(lockedAtTime).format('YYYY-MM-DD HH:mm:ss'), moment().format("YYYY-MM-DD HH:mm:ss"));
        let newMsgTimeDiff = timeDifferenceInSeconds(moment(dateCreated).format('YYYY-MM-DD HH:mm:ss'), moment().format("YYYY-MM-DD HH:mm:ss"));
        let timeInMinsHour = secondsToMinutesHour(newMsgTimeDiff);
        const shouldDisplayTimer = direction && direction.toLowerCase() === INCOMING && !isAutoEscalated && !hasEmployeeSeen && !messageActioned && dateCreated;
        const user = getCurrentUser();
        const lockedByCurrentUser = _.get(message, 'lockedByUser') === user.id;
        let durationIcon;

        if(showCheckbox && !setCheckbox){
            this.setState({setCheckbox: showCheckbox});
            showSelectAll(showCheckbox);
            getCheckboxMessages(messageId);
        }

        if(lockedAtTime && lockedMsgTimeDiff < LOCK_DURATION_IN_SECS && !lockedByCurrentUser){
            durationIcon = <MessageLockIcon className={`color-grey-mid ${styles["mt6"]}`} fontSize={'small'}/>
        }else if(shouldDisplayTimer && showGreenTimer(handleType, newMsgTimeDiff)){
            durationIcon = <Tooltip
                title={timeInMinsHour}
                placement={'bottom-start'}
                enterDelay={100}>
                <TimerIcon className={`color-green ${styles["mt6"]}`} fontSize={'small'}/>
            </Tooltip>
        }else if(shouldDisplayTimer && showRedTimer(handleType, newMsgTimeDiff)){
            durationIcon = <Tooltip
                title={timeInMinsHour}
                placement={'bottom'}
                enterDelay={100}>
                <TimerIcon className={`color-danger ${styles["mt6"]}`} fontSize={'small'} />
            </Tooltip>
        }

        return (
            <TableRow key={messageId}>
                <TableCell className={styles.tableCell} sx={{ width: '150px',  minWidth: '150px'  }}>
                    <a href={`messages/${messageId}?platform=${platform}`} className="tms-no-underline">
                        <span className={`font-14 ${styles["typography14"]}`}> {message.organizationName} </span>
                    </a>
                </TableCell>
                <TableCell className={styles.tableCell} sx={{width: '70px', maxWidth: '80px', padding: '0 6px'}}>
                    <a href={`messages/${messageId}?platform=${platform}`} className="tms-no-underline">
                        <MessageStatusV2
                            message={message}
                            classes={classes}
                            platform={platform}
                        />
                    </a>
                </TableCell>
                <TableCell className={styles.tableCell} sx={{width: '70px', maxWidth: '80px'}}>
                    <a href={`messages/${messageId}?platform=${platform}`} className="tms-no-underline">
                        <span className={`font-14 ${styles["typography14"]}`}> {direction} </span>
                    </a>
                </TableCell>
                <TableCell className={styles.tableCell} sx={{flexGrow: 1, maxWidth: '250px'}}>
                    <BasicTooltip
                        title={
                            <Box className={styles.tooltipTitleWrapper}>
                                <Typography className={`${styles.tooltipTypography} tms-truncate-3-lines`}>
                                    {text}
                                </Typography>
                            </Box>
                        }
                        enterDelay={700}
                        placement='bottom'
                    >
                        <a href={`messages/${messageId}?platform=${platform}`} className="btn-link tms-no-underline">
                            <span className={`font-14 truncate-string ${styles["typography14"]}`}> {text}</span>
                            {(direction && direction.toLowerCase() === OUTGOING && message.isDispatchedSuccessfully) &&
                                <i className="paid-message-icon" title="Paid Message">Paid</i>
                            }
                        </a>
                    </BasicTooltip>
                </TableCell>
                <TableCell className={styles.tableCell} sx={{width: '100px'}}>
                    <span className={`font-14 ${styles["typography14"]}`}>
                       {moment(dateCreated).format('MMM DD hh:mm A z')}{timezone}
                    </span>
                </TableCell>
                <TableCell className={styles.tableCell} sx={{width: '100px'}}>
                    <span className={`font-14 ${styles["typography14"]}`}>
                        {moment(createdDate).format('MMM DD hh:mm A z')}{timezone}
                    </span>
                </TableCell>
                <TableCell className={styles.tableCell} sx={{width: "30px", minWidth: '30px'}}>
                    {durationIcon}
                </TableCell>
                <TableCell className={styles.tableCell} sx={{width: "30px", minWidth: '30px'}}>
                    {showCheckbox &&
                        <Checkbox
                            checked={isChecked}
                            onChange={selectItem}
                            value={messageId}
                            sx={{
                                color: "#c8c8c8",
                                padding: "7px",
                                '&.Mui-checked': {
                                    color: "#003300",
                                },
                            }}
                        />
                    }
                </TableCell>
                <TableCell className={styles.tableCell} sx={{width: "20px", minWidth: '20px'}}>
                    <IconButton
                        aria-label="More"
                        aria-owns={open ? 'long-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                        sx={{padding: "7px", fontSize: 2}}
                    >
                        <MoreVertIcon size="small"/>
                    </IconButton>

                    <Menu
                        id="long-menu"
                        anchorEl={anchorElement}
                        open={open}
                        onClose={this.handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MessageActionsV2
                            message={message}
                            mainMessage={message}
                            updateMessageFromSource={updateMessageFromSource}
                            skipMessage={skipMessage}
                            classes={classes}
                            blacklist={blacklist}
                            platform={platform}
                            handleClose={this.handleClose}
                            isMessageActioned={messageActioned}
                            escalateMessage={escalateMessage}
                            deleteMessageFromSource={deleteMessageFromSource}
                            closeModalHandler={closeModalHandler}
                            showModalHandle={showModalHandle}
                            showEditModalButton={true}
                            showUndoButton={true}
                            undoMessage={undoMessage}
                            resendForResponseGenList={resendForResponseGenList}
                            sendMessageForResponseGen={sendMessageForResponseGen}
                            likeMessageFromSource={likeMessageFromSource}
                            actionMessage={actionMessage}
                        />
                    </Menu>
                </TableCell>
            </TableRow>
        );
    };
}

export { MessagesRowV2 }
